import { useState, useEffect, useRef } from 'react'
import { useSelector } from 'statux'
import { Link } from 'react-router-dom'
import Lottie from 'lottie-react'

import RichText from '../../../components/RichText/RichText'

import { interpolate } from '../../../utils/strings'

export default function Hero (props = {
    heading: null,
    text: null,
    cta: null,
    textSecondary: null,
    lottie: null,
    items: null
}) {
    const state = useSelector() || {}

    const { user } = state

    const lottieRef = useRef()

    const items = Array.isArray(props.items)
        ? props.items
            .filter(obj => obj.richText)
        : []

    const [animationData, setAnimationData] = useState()

    useEffect(() => {
        props.lottie
            && window.fetch(props.lottie)
                .then(res => res.json())
                .then(setAnimationData)
                .catch(err => console.warn(err))
    }, [])

    useEffect(() => {
        const lottieInterval = setInterval(() => {
            if (!lottieRef.current
                    || !lottieRef.current.animationItem)
                return

            clearInterval(lottieInterval)

            const wrapper = lottieRef.current
                .animationItem
                .wrapper

            const bounds = wrapper.getBoundingClientRect()

            const isVisibleTop = bounds.top >= 0
                && bounds.top < window.innerHeight

            const isVisibleBottom = bounds.bottom >= 0
                && bounds.bottom < window.innerHeight

            const isVisibleFull = isVisibleTop && isVisibleBottom

            const partialAnimateThreshold = 0.6

            const isAnimate = isVisibleFull
                || (isVisibleTop
                    && (((bounds.top - window.innerHeight)
                        / bounds.height) > partialAnimateThreshold))
                || (isVisibleBottom
                    && (((bounds.top + bounds.height)
                        / bounds.height) > partialAnimateThreshold))

            lottieRef.current.setSubframe(false)

            if (isAnimate)
                return lottieRef.current.play()

            const lastFrame = lottieRef.current.getDuration(true)

            lottieRef.current
                .goToAndStop(lastFrame, true)
        }, 17)
    }, [lottieRef])

    if (!props.heading
            && !props.text
            && !items.length)
        return null

    let {
        cta,
        heading,
        text
    } = props

    if (typeof (cta || {}).text === 'string')
        cta.text = interpolate(cta.text, state)

    if (typeof heading === 'string')
        heading = interpolate(heading, state)

    if (typeof text === 'string')
        text = interpolate(text, state)

    const isCta = Boolean(cta
        && cta.href
        && (cta.href !== '#registration'
            || !user)
        && cta.text)

    return (
        <section className="hero theme-dark">
            <div className="container">
                {(heading || text)
                    && (
                        <div className="row flex-align-items-center flex-justify-content-space-between">
                            <div className="col-12 col-6-md col-5-lg-up display-flex-md-down flex-direction-column pad-4-t-xl-up pad-4-b-xl-up">
                                {heading
                                    && <h1 className="text-underscore">{heading}</h1>}
                                {text
                                    && <p className="body-2">{text}</p>}
                                {isCta
                                    && (
                                        <Link
                                            to={cta.href}
                                            className={`btn-lg${
                                                text
                                                    ? ' margin-4-t'
                                                    : ''}`}
                                        >
                                            {cta.text}
                                        </Link>
                                    )}
                                {props.textSecondary
                                    && (
                                        <RichText
                                            className={`body-1${text
                                                    || isCta
                                                ? ' margin-4-t'
                                                : ''}`}
                                            html={props.textSecondary}
                                        />)}
                            </div>
                            <div
                                className="col-12 col-6-md col-5-lg-up pad-0-l-lg-up pad-5-t-md-down pad-5-l-md-down pad-5-r-md-down"
                                aria-hidden="true"
                            >
                                <div className="hero-gfx">
                                    {animationData
                                        && (
                                            <Lottie
                                                lottieRef={lottieRef}
                                                animationData={animationData}
                                                autoplay={false}
                                                loop={false}
                                            />)}
                                </div>
                            </div>
                        </div>)}
                {Boolean(items.length)
                    && (
                        <div className="pad-5-t serif">
                            <div className="card-secondary pad-2-t-lg-down pad-2-b-lg-down pad-4-t-lg-up pad-4-b-lg-up margin-5-t-lg-up">
                                <div className="row flex-justify-content-center">
                                    <div className="col-12 col-10-xl-up pad-0-l-xl-up pad-0-r-xl-up">
                                        <ul className="row flex-align-items-center flex-justify-content-center">
                                            {items
                                                .map((obj, idx) => (
                                                    <li
                                                        key={`hero-item-${idx}`}
                                                        className="col col-12-lg-down pad-3-r pad-4-r-md pad-3-l-md-up"
                                                    >
                                                        <div className="display-flex pad-3-t-lg-down pad-3-b-lg-down">
                                                            <svg
                                                                className="icon-check-circle flex-none"
                                                                width="24"
                                                                height="24"
                                                            >
                                                                <use xlinkHref="#icon-check-circle" />
                                                            </svg>
                                                            <RichText
                                                                className="pad-l"
                                                                html={obj.richText}
                                                            />
                                                        </div>
                                                    </li>
                                                ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>)}
            </div>
        </section>
    )
}
